<template>
    <div class="d-flex align-items-center">
        <div v-if="user.name" class="symbol symbol-40 symbol-light-primary flex-shrink-0 mr-3">
            <span class="symbol-label font-weight-bold">{{ $initials(user.name) }}</span>
        </div>
        <div>
            <div v-if="user.name" class="text-dark-75 font-weight-bold font-size-lg">{{ user.name }}</div>
            <a :href="'mailto:' + user.email" class="text-muted font-weight-bold text-hover-primary">
                {{ user.email }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        user: Object
    },
}
</script>
